export default __webpack_public_path__ + "static/media/txt.55bc30fa.png";